import { useCallback, useRef } from 'react';
import type { Ref } from 'react';

/**
 * 合并ref
 * @param refs 
 * @returns 
 */
export const useMergedRef = <T,>(...refs: (Ref<T> | undefined)[]): ((node: T) => void) => {
    const refsRef = useRef(refs);
    refsRef.current = refs;
    return useCallback((node: T) => {
        refsRef.current.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(node);
            } else if (ref != null) {
                (ref as { current: T | null }).current = node;
            }
        });
    }, []);
};
